module.exports = __webpack_public_path__ + "static/media/clarima_flourenza.ce7aecae.jpg";